module.exports = __webpack_public_path__ + "static/media/Fence.bf6e2636.obj";